import { render, staticRenderFns } from "./ProductRecommendationsCardsSmall.vue?vue&type=template&id=61461244&scoped=true&"
import script from "./ProductRecommendationsCardsSmall.vue?vue&type=script&lang=js&"
export * from "./ProductRecommendationsCardsSmall.vue?vue&type=script&lang=js&"
import style0 from "./ProductRecommendationsCardsSmall.vue?vue&type=style&index=0&id=61461244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61461244",
  null
  
)

export default component.exports